import moment from "moment";
import { ALERT } from "../../components/CustomAlert";
import { EncryptedText, DecryptedText } from "../Encryption";
import { Base_API } from "../../_actions/matcher";

// let checkSessionExpiresIn = setInterval(() => {
//     console.log('check session expiresin!');
//     SessionChecker();
// }, 3000)

export const SessionChecker = async() => {
    console.log('SessionChecker Running!!');
    try {
        let lastActive = !!localStorage.getItem(
            process.env.REACT_APP_ENC_SESSION_LAST_ACTIVE) ? DecryptedText(localStorage.getItem(
            process.env.REACT_APP_ENC_SESSION_LAST_ACTIVE), 1) : null;

        if (!!lastActive) {
            // Check last active, must not exceed 1 hour
            let lastDateTime = moment(lastActive, 'DD/MM/YYYY HH:mm:ss');
            let currentDateTime = moment();
            let duration = moment.duration(currentDateTime.diff(lastDateTime));
            // let hoursDifference = duration.asHours();
            let minutesDifference = duration.asMinutes();
            
            if (minutesDifference > 70) { // it's expired
                let accept_signin_policy = localStorage.getItem(process.env.REACT_APP_ENC_NAME_ACCEPT_SIGNIN_POLICY); // เคยกดยินยอมเงื่อนไขแล้ว
                localStorage.clear();
                localStorage.setItem(process.env.REACT_APP_ENC_NAME_ACCEPT_SIGNIN_POLICY, accept_signin_policy);
                // Exceeded 15 minutes
                ALERT.customAlert('เซสชั่นหมดอายุ', '', 'ตกลง', () => {
                    location.href = `${Base_API.pathWeb}/n-health/mycard`;
                })
            } else {
                // Not exceeded 1 hour
                createSession();
            }
        } else {
            createSession();
        }
    } catch (error) {
        console.error('Session Checker Error: ', error);
    }
};
async function createSession() {
    // Create new session with datetime now (DD/MM/YYYY HH:mm:ss)
    let dateTimeNow = EncryptedText(moment().format('DD/MM/YYYY HH:mm:ss'));
    localStorage.setItem(
        process.env.REACT_APP_ENC_SESSION_LAST_ACTIVE, dateTimeNow);
}